import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ValidationMatriculaComponent } from './components/validation-matricula/validation-matricula.component';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { DocumentosCertiComponent } from './components/documentos-certi/documentos-certi.component';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SegemCertificacionComponent } from './components/segem-certificacion/segem-certificacion.component';
@NgModule({
  declarations: [
    AppComponent,
    ValidationMatriculaComponent,
    HeaderComponent,
    FooterComponent,
    DocumentosCertiComponent,
    SegemCertificacionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    PdfViewerModule,
    HttpClientModule,
    NgxExtendedPdfViewerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
